import { useState, useEffect, useCallback, useMemo } from 'react';
import { UpOutlined } from '@ant-design/icons';
import styles from './index.module.css';

interface UseScrollHandlerProps {
    total: number;
    length: number;
    loading?: boolean;
    isTopButton?: boolean;
    disable?: boolean;
    onScrollButton?: () => void;
}
/**
 * @description: 滚动事件处理 hook 用于处理滚动到底部加载更多
 * @param {UseScrollHandlerProps} param1
 * @return {*}
 */
const useScrollHandler = ({ loading = false, isTopButton = false, total, length, disable = false, onScrollButton }: UseScrollHandlerProps) => {
    // 是否显示返回顶部按钮
    const [isShowTopButton, setShowTopButton] = useState<boolean>(false);

    // 监听body是否滚动到底部
    const handleScroll = useCallback(() => {
        if (window.scrollY === 0) {
            setShowTopButton(false);
        }
        if (window.scrollY !== 0 && !isShowTopButton) {
            setShowTopButton(true);
        }
        // 检测滚动条是否滚动到底部
        if (Math.floor(window.scrollY + window.innerHeight) >= document.documentElement.scrollHeight) {
            console.log('已经滚动到底部');
            onScrollButton && onScrollButton();
        }
    }, [isShowTopButton, onScrollButton]);
    // 监听滚动事件
    useEffect(() => {
        if (!window || disable) return;
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll, disable]);
    // 返回顶部
    const toScrollTop = () => {
        // 返回顶部
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    // 返回顶部render
    const toTopRender = useMemo(() => {
        return isTopButton && isShowTopButton ? (
            <button aria-label="返回顶部" className={styles.top_button} onClick={toScrollTop}>
                <UpOutlined /> 回到顶部
            </button>
        ) : null;
    }, [isShowTopButton, isTopButton]);
    // 是否加载完成
    const isFinish = useMemo(() => {
        // children的长度是否等于total
        if (total === 0) return false;
        if (!length) return false;
        if (!length) return false;
        return total === length;
    }, [total, length]);
    // 到底render
    const finishRender = useMemo(() => {
        return isFinish ? <div className={styles.finish}>已经到底了</div> : null;
    }, [isFinish]);
    // 加载中render
    const loadingRender = useMemo(() => {
        return loading ? <div className={styles.loading}>加载中...</div> : null;
    }, [loading]);

    return {
        toTopRender,
        finishRender,
        loadingRender,
    };
};

export default useScrollHandler;